export const roles = [
  ['/info-center', '/profile', '/billing', '/games', '/file-manager'], // Role 0 - Basic user with profile access only
  ['/info-center', '/profile', '/billing', '/games', '/file-manager'], // Role 1 - Basic user with profile access only
  [
    '/info-center',
    '/establishements',
    '/classes',
    '/users',
    '/subjects',
    '/remarques',
    '/exams',
    '/national-exams',
    '/admin-documents',
    '/qcm',
    '/exercices',
    '/video-gallery',
    '/quiz-leaderboard',
    '/ranking-board',
    '/grades',
    '/inventory',
    '/inventory-types',
    '/inventory-statistics',
    '/type-exams',
    '/type-remarques',
    '/payment-categories',
    '/payments',
    '/billing',
    '/payroll',
    '/payroll-categories',
    '/expenditures',
    '/profile',
    '/promotions',
    '/statistiques',
    '/email-management',
    '/users/infos',
    '/games',
    '/file-manager',
  ], // Role 2 - Admin (Full access)
  ['/info-center', '/exercices', '/video-gallery', '/quiz-leaderboard', '/ranking-board', '/remarques', '/profile', '/exams', '/national-exams', '/qcm', '/grades', '/users/details', '/payments', '/billing', '/payroll', '/games', '/file-manager'], // Role 3 - Teacher
  ['/info-center', '/exercices', '/video-gallery', '/quiz-leaderboard', '/ranking-board', '/remarques', '/profile', '/exams', '/national-exams', '/admin-documents', '/qcm', '/grades', '/payments', '/billing', '/games', '/file-manager'], // Role 4 - Student (Grades = Report card)
  ['/info-center', '/kids', '/exercices', '/video-gallery', '/quiz-leaderboard', '/ranking-board', '/remarques', '/profile', '/exams', '/national-exams', '/admin-documents', '/qcm', '/grades', '/payments', '/billing', '/games', '/file-manager'], // Role 5 - Parent (Grades = Report card)
  ['/info-center', '/payments', '/billing', '/profile', '/payment-categories', '/users', '/expenditures', '/admin-documents', '/games', '/file-manager'], // Role 6 - Finance Manager / Gestionnaire financier
  ['/info-center', '/inventory', '/inventory-types', '/profile', '/billing', '/games', '/file-manager'], // Role 7 - Stock Manager
  ['/info-center', '/profile', '/payments', '/billing'], // Role 8 - Limited Student (Profile + Payments only)
  ['/info-center', '/payroll', '/payroll-categories', '/profile', '/billing', '/expenditures', '/users'], // Role 9 - Accountant / Comptable (Payroll-only)
  ['/info-center', '/exercices', '/video-gallery', '/quiz-leaderboard', '/ranking-board', '/remarques', '/profile', '/exams', '/national-exams', '/admin-documents', '/qcm', '/grades', '/subjects', '/users/details', '/expenditures', '/payments', '/billing', '/games', '/file-manager'], // Role 10 - Secretary / Secrétaire (Teacher + Subjects management)
]

export const resolveRoleIndex = (role: string | number | undefined | null): number | null => {
  if (role === undefined || role === null) {
    return null
  }

  // 1) Direct numeric roles (e.g. '2', 3, 9 ...)
  const numeric = Number(role)
  if (!Number.isNaN(numeric)) {
    return numeric
  }

  const roleStr = `${role}`.toLowerCase().trim()

  // 2) Named roles coming from backend (e.g. 'ROLE_ACCOUNTANT', 'ACCOUNTANT', etc.)
  const map: Record<string, number> = {
    // Existing numeric mappings can be added here if backend ever sends names
    role_admin: 2,
    admin: 2,
    administrator: 2,
    role_teacher: 3,
    teacher: 3,
    role_student: 4,
    student: 4,
    role_parent: 5,
    parent: 5,
    role_finance: 6,
    finance: 6,
    finance_manager: 6,
    role_accountant: 9,
    accountant: 9,
    comptable: 9,
    role_secretary: 10,
    secretary: 10,
    secretaire: 10,
    role_secretaire: 10,
  }

  if (map[roleStr] !== undefined) {
    return map[roleStr]
  }

  // 3) Try to extract any digits if the role is like 'ROLE_9'
  const match = roleStr.match(/\d+/)
  if (match) {
    const extracted = Number(match[0])
    return Number.isNaN(extracted) ? null : extracted
  }

  return null
}
